import Home from './Home'


const Admin = {
	Home
}

export default Admin